// extracted by mini-css-extract-plugin
module.exports = {"header":"DlpHeader_header__PIasp","title":"DlpHeader_title__eTIk9","subTitle":"DlpHeader_subTitle__J2LWS","searchBar":"DlpHeader_searchBar__HtO_E"};